export default "__VITE_ASSET__CMaMEW$C__"